module.exports = __webpack_public_path__ + "img/rect_red_left.b1e0369e.png";